var _this = this;
import * as tslib_1 from "tslib";
import addInfoBarMessage from '../actions/addInfoBarMessage';
import setIsSending from '../actions/setIsSending';
import getRecipientsCount from '../utils/getRecipientsCount';
import resolveFindControlText from '../utils/resolveFindControlText';
import { getTotalRecipientCount } from '../utils/viewStateUtils';
import { computed } from 'mobx';
import { getComposeHostItemIndex, isAnyUilessAddinRunning } from 'owa-addins-core';
import { logUsage } from 'owa-analytics';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { lazyHasPendingAttachments } from 'owa-attachment-well-data';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { isPreviewPaneDisplayed } from 'owa-preview-pane-store';
import { lazyCanClosePreviewPane } from 'owa-preview-pane-store';
import resolveAllUnresolvedRecipients from 'owa-readwrite-recipient-well/lib/actions/resolveAllUnresolvedRecipients';
import getNumberInvalidRecipients from 'owa-readwrite-recipient-well/lib/utils/getNumberInvalidRecipients';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-mail-strings';
import { isSxSDisplayed } from 'owa-sxs-store';
import { lazyCanCloseSxS } from 'owa-sxs-store';
import { trace } from 'owa-trace';
function markDatapointAsWaiting(datapoint) {
    if (datapoint) {
        datapoint.addCustomData({
            waitingUserAction: true.toString(),
        });
    }
}
/** Comments in the below object reference validation steps from JsMVVM that are as-yet-implemented in owamail */
var computedValidationSteps = computed(function () {
    return [
        /** if (this.discardManager.HasDiscarded(composeViewModel.Context.ViewModelId)) */
        /** else if (recipientComponent.IsFromRecipientInvalid) */
        {
            validate: function (viewState, datapoint) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var hasInvalidRecipient, _i, _a, recipientWell;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            hasInvalidRecipient = false;
                            _i = 0, _a = [
                                viewState.toRecipientWell,
                                viewState.ccRecipientWell,
                                viewState.bccRecipientWell,
                            ];
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            recipientWell = _a[_i];
                            if (!recipientWell) return [3 /*break*/, 3];
                            return [4 /*yield*/, resolveAllUnresolvedRecipients(recipientWell, function () {
                                    markDatapointAsWaiting(datapoint);
                                })];
                        case 2:
                            _b.sent();
                            if (recipientWell.inForceResolve) {
                                hasInvalidRecipient = true;
                                logUsage('sendInvalidRecipients', [
                                    getNumberInvalidRecipients(recipientWell),
                                    recipientWell.findResultSet.length,
                                ]);
                                return [3 /*break*/, 4];
                            }
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, !hasInvalidRecipient];
                    }
                });
            }); },
            errorCode: 'InvalidRecipients',
        },
        {
            validate: function (viewState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    resolveFindControlText(viewState.toRecipientWell);
                    resolveFindControlText(viewState.ccRecipientWell);
                    resolveFindControlText(viewState.bccRecipientWell);
                    return [2 /*return*/, (getRecipientsCount(viewState.toRecipientWell) > 0 ||
                            getRecipientsCount(viewState.ccRecipientWell) > 0 ||
                            getRecipientsCount(viewState.bccRecipientWell) > 0)];
                });
            }); },
            messageId: 'errorMessageNoRecipentsMailCanNotBeSend',
            errorCode: 'NoRecipients',
        },
        {
            text: strings.attachmentInProgress,
            validate: function (viewState) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lazyHasPendingAttachments.import()];
                    case 1: return [2 /*return*/, !(_a.sent())(viewState.attachmentWell)];
                }
            }); }); },
            errorCode: 'AttachmentInProgress',
        },
        {
            validate: function (viewState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var totalRecipients;
                return tslib_1.__generator(this, function (_a) {
                    totalRecipients = getTotalRecipientCount(viewState);
                    return [2 /*return*/, totalRecipients <= getUserConfiguration().MaxRecipientsPerMessage];
                });
            }); },
            messageId: 'warningMessageMaxRecipientsExceed',
            errorCode: 'MaxRecipients',
        },
        {
            // The user might be editing an attachment in the preview pane.
            // Wait until the preview pane is either ready for send or
            // is unable to save the attachment - canClosePreviewPane
            // returns a promise to achieve this so we have to await
            // on the result of the promise
            validate: function (viewState, datapoint) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!isAttachmentFeatureEnabled('doc-SxS-refactor')) return [3 /*break*/, 3];
                            if (!isSxSDisplayed()) {
                                return [2 /*return*/, true];
                            }
                            markDatapointAsWaiting(datapoint);
                            return [4 /*yield*/, lazyCanCloseSxS.import()];
                        case 1: return [4 /*yield*/, (_a.sent())()];
                        case 2: return [2 /*return*/, _a.sent()];
                        case 3:
                            if (!isPreviewPaneDisplayed()) {
                                return [2 /*return*/, true];
                            }
                            markDatapointAsWaiting(datapoint);
                            return [4 /*yield*/, lazyCanClosePreviewPane.import()];
                        case 4: return [4 /*yield*/, (_a.sent())()];
                        case 5: return [2 /*return*/, _a.sent()];
                    }
                });
            }); },
            messageId: 'errorMessageFileCanNotBeSaved',
            errorCode: 'CantClosePreviewPane',
        },
        /** else if (PolicyTipsUtilities.IsEnabled && policyTipsComponent.IsSendBlocked()) */
        {
            text: strings.missingSubjectTitle,
            subtext: strings.missingSubjectSubTitle,
            confirmOptions: {
                okText: strings.sendAnywayButton,
                cancelText: strings.doNotSendAnywayButton,
            },
            validate: function (viewState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    return [2 /*return*/, viewState.isInlineCompose ||
                            (viewState.subject && viewState.subject.length > 0)];
                });
            }); },
            continueOnUserConfirmation: true,
            errorCode: 'NoSubject',
        },
        {
            text: strings.blockOnNavigationTitle,
            subtext: strings.blockOnNavigationSendMessage,
            confirmOptions: {
                okText: strings.blockOnNavigationSendLabel,
                cancelText: strings.blockOnNavigationDontSendLabel,
            },
            validate: function (viewState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    if (!isMailFeatureEnabled('rp-addins')) {
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, !isAnyUilessAddinRunning(getComposeHostItemIndex(viewState.composeId))];
                });
            }); },
            continueOnUserConfirmation: true,
            errorCode: 'AddinsStillRunning',
        },
    ];
});
function validateStep(step, viewState, datapoint) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var validationResult, confirmResult;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, step.validate(viewState, datapoint)];
                case 1:
                    validationResult = _a.sent();
                    if (!!validationResult) return [3 /*break*/, 4];
                    if (!step.messageId) return [3 /*break*/, 2];
                    addInfoBarMessage(viewState, step.messageId);
                    return [3 /*break*/, 4];
                case 2:
                    if (!(step.text != undefined)) return [3 /*break*/, 4];
                    markDatapointAsWaiting(datapoint);
                    return [4 /*yield*/, confirm(step.text, step.subtext, false /*resolveImmediately*/, step.confirmOptions)];
                case 3:
                    confirmResult = _a.sent();
                    validationResult =
                        step.continueOnUserConfirmation && confirmResult === DialogResponse.ok;
                    _a.label = 4;
                case 4: return [2 /*return*/, Promise.resolve(validationResult)];
            }
        });
    });
}
export default function validateSend(viewState, datapoint) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var validationSteps, i, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    validationSteps = computedValidationSteps.get();
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < validationSteps.length)) return [3 /*break*/, 6];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, validateStep(validationSteps[i], viewState, datapoint)];
                case 3:
                    if (!(_a.sent())) {
                        return [2 /*return*/, Promise.resolve(validationSteps[i].errorCode)];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    setIsSending(viewState, false /*isSending*/);
                    trace.warn(e_1);
                    return [2 /*return*/, Promise.reject(e_1)];
                case 5:
                    i++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/, Promise.resolve(null)];
            }
        });
    });
}
//# sourceMappingURL=validateSend.js.map